var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"font-bold py-2 px-4 rounded flex items-center",on:{"click":_vm.clicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }